import AuthenticatedResource from 'resources/AuthenticatedResource';

// --------------------------------------------------------
// Resource Definition
// --------------------------------------------------------

export default class CategoryResource extends AuthenticatedResource {
  static urlRoot = '/organization/:organization/categories/';

  id                = undefined;
  name              = undefined;
  number_of_records = 0;
  path              = [];
  sub_groups        = [];
  created_at        = null;
  updated_at        = null;

  pk() {
    return this.id && this.id.toString();
  }
}
